<script setup lang="ts">
import { useI18n } from "vue-i18n";
import VIcon from "../Icon/VIcon.vue";

defineOptions({
  name: "VTableBulkBar",
});

/**
 * The green bar under the toolbar while rows are selected: how many, "Selectie wissen" and the bulk actions on the
 * right (small gray buttons, a destructive one outlined in red last).
 */
const { label, canClear } = defineProps<{
  /** "3 gebruikers geselecteerd". */
  label: string
  canClear: boolean
}>();

const emit = defineEmits<{
  clear: []
}>();

defineSlots<{
  default?: () => unknown
}>();

const { t } = useI18n();
</script>

<template>
  <div
    class="v-table-bulk flex flex-wrap items-center gap-x-3 gap-y-2 border-t border-primary-100 bg-primary-50 px-3.5 py-2.5 text-[13px] text-primary-900 dark:border-primary-800 dark:bg-primary-900/30 dark:text-primary-300"
    role="region"
    :aria-label="t('base.table.bulk_actions')"
    data-testid="table-bulk-bar"
  >
    <span class="inline-flex items-center gap-2 font-medium" role="status">
      <VIcon name="square-check" aria-hidden="true" />
      {{ label }}
    </span>
    <button
      v-if="canClear"
      type="button"
      class="h-7 cursor-pointer rounded-full px-1 text-xs text-primary-900 underline hover:no-underline focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-primary-500 dark:text-primary-300"
      data-testid="table-bulk-clear"
      @click="emit('clear')"
    >
      {{ t("base.table.clear_selection") }}
    </button>
    <span class="flex-1" />
    <div class="flex flex-wrap items-center gap-2">
      <slot />
    </div>
  </div>
</template>
